import type { PlanShelf } from '@features/workshop-plan/types';
import type { PlanFocus } from '@features/workshop-plan/utils/plan-cell';

import { getBands, matchesFocus } from '@features/workshop-plan/utils/plan-cell';
import { PlanCellTile } from '@features/workshop-plan/components/plan-cell-tile';

const CELL_HEIGHT = '4.5rem';

type Props = {
  shelf: PlanShelf;
  focus: PlanFocus;
};

/**
 * Front view of a shelf: level 1 on top, one row per band. A band starts at its first level, spans its levels
 * and splits its width equally between its cells, in rank order. Rows have a fixed height, so a level with no
 * band keeps its size.
 */
export const PlanShelfGrid = ({ shelf, focus }: Props) => (
  <div className="grid gap-1" style={{ gridTemplateRows: `repeat(${shelf.levels}, ${CELL_HEIGHT})` }}>
    {getBands(shelf).map((band) => (
      <div className="flex min-w-0 gap-1" key={band.level} style={{ gridRow: `${band.level} / span ${band.span}` }}>
        {band.cells.map((cell) => (
          <div className="grid min-w-0 flex-[1_1_0]" key={cell.id}>
            <PlanCellTile cell={cell} dimmed={!matchesFocus(cell, focus)} minHeight={0} />
          </div>
        ))}
      </div>
    ))}
  </div>
);
